import React from 'react';

/**
 * Full-bleed hero background with gradient scrims and optional overlay children.
 */
export default function StitchHeroImage({ src, alt, className = '', children, minHeightClass = 'min-h-[520px]' }) {
  return (
    <div className={`relative overflow-hidden ${minHeightClass} ${className}`}>
      <img
        src={src}
        alt={alt}
        className="absolute inset-0 h-full w-full object-cover"
        loading="eager"
        decoding="async"
      />
      <div
        className="absolute inset-0 bg-gradient-to-t from-background via-background/80 to-transparent"
        aria-hidden
      />
      <div
        className="absolute inset-0 bg-gradient-to-r from-background via-background/40 to-transparent"
        aria-hidden
      />
      <div className="relative z-10 flex h-full flex-col justify-end p-6 sm:p-10 lg:p-12">{children}</div>
    </div>
  );
}
